import React from "react";
import { ReactSession } from 'react-client-session';
import {encode as base64_encode} from 'base-64';
import { toast } from 'react-toastify';
import { Modal, ModalBody } from 'reactstrap';

import { Helpers } from "../../config/Helpers";

class PaymentList extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            loading: true,
            orderData: [],
            orderList: [],
            totalOrder: 0,
            orderCheckTotal: [],
            showUploadModal: false,
            uploading: false,
            tglPembayaran: '',
            jmlTransfer: '',
            namaBank: '',
            namaPemilikRekening: '',
            noRekening: '',
            keteranganTransfer: '',
            lampiranName: '',
            lampiranBase64: '',
            lampiranPreview: '',
            infoBankName: '',
            infoBankNumber: '',
            infoBankAccount: '',
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getListOrder();
            this.getBankInfo();
        }
    }

    getListOrder = () => {
        this.setState({ loading: true });

        Helpers.getListOrderCustom(
            'yes',
            this.state.sessUserCode,
            'waiting_pay',
            'all',
            'all',
            '',
            ''
        ).then(res => {
            if(res && res.length > 0){
                const orderList = res.map(obj => Object.assign({}, obj, {Checked: "t"}));

                this.setState({
                    orderData: res,
                    orderList: orderList,
                    loading: false
                }, () => {
                    this.recalculate();
                });
            }else{
                this.setState({ loading: false });
            }
        });
    };

    getBankInfo = () => {
        Helpers.GetInformationKode(
            this.state.sessUserCode,
            this.state.sessEmail
        ).then(res => {
            if(res && res.length > 0){
                const obj = res[0];

                this.setState({
                    infoBankName: obj.bank_name,
                    infoBankNumber: obj.bank_number,
                    infoBankAccount: obj.bank_account,
                });
            }
        });
    };

    recalculate = () => {
        const checked = this.state.orderList.filter(obj => obj.Checked === "t");

        this.setState({
            totalOrder: checked.reduce((sum, { GrandTotal }) => sum + parseInt((GrandTotal || '0').toString().replaceAll(".","")), 0),
            orderCheckTotal: checked
        }, () => {
            this.setState({
                jmlTransfer: (this.state.totalOrder) ? this.state.totalOrder.toString() : ''
            });
        });
    };

    handleToggleChecked = (kode, checked) => {
        const orderList = this.state.orderList.map((obj) => {
            if(obj.KodeTransaksiOrder === kode){
                return Object.assign({}, obj, { Checked: checked });
            }
            return obj;
        });

        this.setState({ orderList }, () => {
            this.recalculate();
        });
    };

    handleToggleSelectAll = () => {
        const allChecked = this.state.orderData.length === this.state.orderCheckTotal.length;
        const checked = allChecked ? 'f' : 't';

        this.setState({
            orderList: this.state.orderList.map(obj => Object.assign({}, obj, { Checked: checked }))
        }, () => {
            this.recalculate();
        });
    };

    handleDeleteAll = () => {
        this.setState({
            orderList: this.state.orderList.map(obj => Object.assign({}, obj, { Checked: 'f' }))
        }, () => {
            this.recalculate();
        });
    };

    openUploadModal = () => {
        if(this.state.orderCheckTotal.length === 0){
            toast.error("Pilih minimal satu pesanan terlebih dahulu!");
            return;
        }

        this.setState({ showUploadModal: true });
    };

    closeUploadModal = () => {
        this.setState({ showUploadModal: false });
    };

    handleClear = (field) => {
        this.setState({ [field]: '' });
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];

        if(!file){
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                lampiranBase64: reader.result,
                lampiranName: file.name,
                lampiranPreview: reader.result
            });
        };
        reader.readAsDataURL(file);
    };

    clearLampiran = () => {
        this.setState({
            lampiranBase64: '',
            lampiranName: '',
            lampiranPreview: ''
        });
    };

    goUploadPayment = () => {
        if(this.state.tglPembayaran && this.state.lampiranBase64){
            this.setState({ uploading: true });

            let listOrder = '';
            this.state.orderList.forEach((obj) => {
                if(obj.Checked === "t"){
                    listOrder = (listOrder) ? listOrder + ',' + obj.KodeTransaksiOrder : obj.KodeTransaksiOrder;
                }
            });

            let data = new FormData();
            data.append("img", this.state.lampiranBase64);
            data.append("img_name", this.state.lampiranName);
            data.append("tanggal", this.state.tglPembayaran);
            data.append("id", listOrder);
            data.append("kodemarketing", this.state.sessUserCode);
            data.append("jumlah", this.state.jmlTransfer);
            data.append("bank_name", this.state.namaBank);
            data.append("bank_account", this.state.namaPemilikRekening);
            data.append("bank_number", this.state.noRekening);
            data.append("email", this.state.sessEmail);
            data.append("keterangan", this.state.keteranganTransfer);

            Helpers.SavePaymentUploadNew(data).then(res => {
                this.setState({ uploading: false });

                if(res && res.length > 0){
                    const obj = res[0];

                    if(obj.alert === 'success'){
                        toast.success(obj.message);

                        setTimeout(function() {
                            window.location.href = './collective-payment';
                        }, 1000);
                    }else{
                        toast.error(obj.message);
                    }
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            });
        }else{
            toast.error("Mohon untuk mengisi tanggal transfer dan mengunggah foto bukti terlebih dahulu");
        }
    };

    render() {
        const allChecked = this.state.orderData.length > 0 && this.state.orderData.length === this.state.orderCheckTotal.length;

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./collective-payment" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">Pesanan Perlu Dibayar</h1>
                    </div>

                    <div className="cart-toolbar">
                        <span className="cart-toolbar-accent"></span>
                        <span className="cart-toolbar-text">{this.state.orderCheckTotal.length} pesanan terpilih</span>
                        <span className="cart-toolbar-delete" onClick={() => {this.handleDeleteAll()}}>
                            <i className="fi-rs-trash"></i> Hapus
                        </span>
                    </div>

                    <div className="detail-wrap">
                        {
                            this.state.loading ? (
                                <div className="detail-card">
                                    <div className="detail-card-head">
                                        <span className="detail-card-accent"></span>
                                        <span className="detail-card-title">Memuat data...</span>
                                    </div>
                                </div>
                            ) : this.state.orderList.length > 0 ? (
                                this.state.orderList.map((object, i) => (
                                    <div className="order-card" key={i}>
                                        <div className="order-card-top">
                                            <div>
                                                <div className="order-card-code">{object.KodeTransaksiOrder}</div>
                                                <div className="order-card-date">{object.dates}</div>
                                            </div>
                                            <input
                                                type="checkbox"
                                                className="cart-item-checkbox"
                                                checked={object.Checked === 't'}
                                                onChange={() => {this.handleToggleChecked(object.KodeTransaksiOrder, (object.Checked === 't') ? 'f' : 't')}}
                                            />
                                        </div>
                                        {
                                            object.cust_owner && (
                                                <div className="order-card-owner">{(object.cust_owner || '').toString().toUpperCase()}</div>
                                            )
                                        }

                                        <div className="order-card-divider"></div>

                                        <div className="order-card-body">
                                            <div className="order-card-thumb">
                                                <img src={object.DisplayOrder} alt=""/>
                                            </div>
                                            <div className="order-card-info">
                                                <div className="order-card-name">{object.DisplayOrderName}</div>
                                                {
                                                    object.TotalItem > 1 && (
                                                        <div className="order-card-more">+{object.TotalItem - 1} Barang Lainnya</div>
                                                    )
                                                }
                                                {
                                                    object.PreOrder === 'yes' && (
                                                        <div className="order-card-preorder">Pre Order</div>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        {
                                            (object.CatatanOrder && object.CatatanOrder !== '-' && object.CatatanOrder !== 'null') && (
                                                <div className="order-card-note">
                                                    <i className="fi-rs-notebook"></i>
                                                    <span>{object.CatatanOrder}</span>
                                                </div>
                                            )
                                        }

                                        <div className="order-card-footer">
                                            <div>
                                                <div className="order-card-total-label">Total Belanja</div>
                                                <div className="order-card-total-value">Rp {object.GrandTotal}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="order-empty">
                                    <i className="fi-rs-receipt"></i>
                                    <p>Tidak ada pesanan yang perlu dibayar</p>
                                </div>
                            )
                        }
                    </div>

                    <div className="checkout-bottom-bar">
                        <div className="checkout-bottom-bar-inner">
                            <span className="cart-selectall">
                                <input type="checkbox" checked={allChecked} onChange={() => {this.handleToggleSelectAll()}}/>
                                Semua
                            </span>
                            <div className="checkout-bottom-total">
                                <span className="checkout-bottom-total-label">Total</span>
                                <span className="checkout-bottom-total-value">Rp {this.state.totalOrder.toLocaleString(undefined, {maximumFractionDigits: 0}).toString().replaceAll(',','.')}</span>
                            </div>
                            <button type="button" className="checkout-bottom-btn" onClick={() => {this.openUploadModal()}}>Bayar ({this.state.orderCheckTotal.length})</button>
                        </div>
                    </div>
                </main>

                <Modal
                    size={'md'}
                    isOpen={this.state.showUploadModal}
                    toggle={() => { this.closeUploadModal() }}
                    contentClassName="modal-picker-content">
                    <ModalBody className="modal-picker-body">
                        <div className="modal-picker-header">
                            <div className="modal-picker-title">
                                <span className="modal-picker-icon"><i className="fi-rs-credit-card"></i></span>
                                Unggah Pembayaran
                            </div>
                            <button type="button" className="modal-picker-close" onClick={() => { this.closeUploadModal() }} aria-label="Tutup">
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>

                        <div className="collective-upload-scroll">
                        <div className="detail-note-box">
                            <i className="fi-rs-info"></i>
                            <span>
                                Cara melakukan pembayaran:<br/><br/>
                                1. Nilai transfer harus sesuai total order<br/>
                                2. Melakukan transfer ke rekening berikut<br/>
                                &nbsp;&nbsp;&nbsp;- {this.state.infoBankName}<br/>
                                &nbsp;&nbsp;&nbsp;- {this.state.infoBankNumber}<br/>
                                &nbsp;&nbsp;&nbsp;- {this.state.infoBankAccount}<br/>
                                3. Unggah bukti transfer melalui form berikut<br/>
                                4. Tunggu verifikasi admin<br/>
                                5. Selesai
                            </span>
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-calendar auth-input-icon"></i>
                            <input
                                type="date"
                                className="location-select"
                                value={this.state.tglPembayaran}
                                onChange={e => this.setState({ tglPembayaran: e.target.value })}
                            />
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-dollar auth-input-icon"></i>
                            <input
                                type="text"
                                placeholder="Jumlah Transfer"
                                value={'Rp ' + this.state.jmlTransfer}
                                readOnly={true}
                            />
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-bank auth-input-icon"></i>
                            <input
                                type="text"
                                placeholder="Nama Bank"
                                value={this.state.namaBank}
                                onChange={e => this.setState({ namaBank: e.target.value })}
                            />
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-user auth-input-icon"></i>
                            <input
                                type="text"
                                placeholder="Nama Pemilik Rekening"
                                value={this.state.namaPemilikRekening}
                                onChange={e => this.setState({ namaPemilikRekening: e.target.value })}
                            />
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-credit-card auth-input-icon"></i>
                            <input
                                type="text"
                                placeholder="No Rekening"
                                value={this.state.noRekening}
                                onChange={e => this.setState({ noRekening: e.target.value })}
                            />
                        </div>

                        <div className="auth-input-group">
                            <i className="fi-rs-comment-alt auth-input-icon"></i>
                            <input
                                type="text"
                                placeholder="Keterangan"
                                value={this.state.keteranganTransfer}
                                onChange={e => this.setState({ keteranganTransfer: e.target.value })}
                            />
                        </div>

                        <div className="collective-upload-box">
                            <label htmlFor="lampiranPembayaran" className="collective-upload-label">
                                <i className="fi-rs-camera"></i> Foto bukti pembayaran
                            </label>
                            <input
                                id="lampiranPembayaran"
                                type="file"
                                accept="image/*"
                                onChange={this.handleFileChange}
                                style={{display: 'none'}}
                            />
                            {
                                this.state.lampiranPreview && (
                                    <div className="collective-upload-preview">
                                        <img src={this.state.lampiranPreview} alt=""/>
                                        <i className="fi-rs-cross-circle" onClick={() => {this.clearLampiran()}}></i>
                                    </div>
                                )
                            }
                        </div>

                        <button type="button" className="auth-btn-primary" disabled={this.state.uploading} onClick={() => {this.goUploadPayment()}}>
                            {this.state.uploading ? 'Mengirim...' : 'Kirim Bukti Pembayaran'}
                        </button>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}

export default PaymentList;
